import * as React from "react";
import { fillTemplateString } from "../commons/utils/text-rendering";
import RemoveAction from "../commons/components/action/RemoveAction";
import TextAreaInput from "../commons/components/form/input/TextAreaInput";
import { required } from "../commons/model/form/Validators";
import TextAction from "../commons/components/action/TextAction";
import Question from "../commons/model/Question";
import InputState from "../commons/model/form/InputState";

export default function SettingsVCQuestionsForm({
  canEditQuestions,
  questions,
  updateInputStates,
  addQuestion,
  updateQuestion,
  removeQuestion,
}: {
  canEditQuestions?: boolean;
  questions: Question[];
  updateInputStates: (string: string, inputstate: InputState) => void;
  addQuestion: () => void;
  updateQuestion: (index: number, value) => void;
  removeQuestion: (index: number) => void;
}) {
  return (
    <>
      {canEditQuestions && (
        <div className="field-groups">
          <h3 className="title">
            {i18n["Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.Title"]}
          </h3>
          {questions.map((question, index) => (
            <React.Fragment key={question.uid}>
              <div className="label">
                <label htmlFor={question.uid}>
                  {fillTemplateString(
                    i18n[
                      "Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.Label.Question"
                    ],
                    { index: String(index + 1) }
                  )}
                </label>
                {questions.length > 1 ? (
                  <RemoveAction
                    id={"remove-question-" + question.uid}
                    label={
                      i18n[
                        "Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.Action.Remove"
                      ]
                    }
                    onClick={() => removeQuestion(index)}
                  />
                ) : null}
              </div>
              <TextAreaInput
                name={question.uid}
                initialValue={question.value}
                maxLength={150}
                rows={2}
                validators={[required()]}
                onChange={(inputState) => {
                  updateInputStates(question.uid, inputState);
                  inputState.value !== question.value && updateQuestion(index, inputState.value);
                }}
              />
            </React.Fragment>
          ))}
          <div />
          {Object.keys(questions).length < 10 && (
            <TextAction
              id={"add-question"}
              label={
                i18n[
                  "Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.Action.Add"
                ]
              }
              icon="ic_plus"
              additionalClass="add-item"
              onClick={() => addQuestion()}
            />
          )}
        </div>
      )}
    </>
  );
}
